import script from "./Closet.vue?vue&type=script&setup=true&lang=js"
export * from "./Closet.vue?vue&type=script&setup=true&lang=js"

import "./Closet.vue?vue&type=style&index=0&id=a5cbfbb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5cbfbb6"]])

export default __exports__